import React from 'react';
import Cinema from '../../components/Cinema';


export default function index (){
    return (
        <>
        <Cinema />

        </>
    ) 
};